import React from 'react';

export const LowScreen: React.FC<React.HTMLAttributes<SVGElement>> = (
  props
) => (
  <svg
    width="23"
    height="23"
    viewBox="0 0 23 23"
    stroke="currentColor"
    strokeWidth="0.65"
    {...props}
  >
    <path d="M0.324998 7.448L7.448 7.448L7.448 0.324998H6.657L6.657 6.657L0.324998 6.657V7.448Z" />
    <path d="M15.993 0.324998H15.202V7.448L22.325 7.448V6.657L15.993 6.657V0.324998Z" />
    <path d="M6.657 22.325H7.448L7.448 15.202H0.324998V15.993H6.657L6.657 22.325Z" />
    <path d="M15.202 22.325H15.993V15.993H22.325V15.202H15.202V22.325Z" />
  </svg>
);
